export default __webpack_public_path__ + "static/Aime-Bold-f46569f4610e44ecf259b437deeb7e6d.woff2";